<template>
  <div>
    <div id="overlay" v-if="loading">
      <div class="spinner"></div>
      <br/>
      <h4>Loading...</h4>
    </div>
    <form class="form-horizontal">
      <div class="p-grid">
        <div class="p-col">
          <Button class="p-button p-component p-button-success addNewBtn btn-btm-0 width-auto" @click.prevent="openBasic" label="New" icon="pi pi-plus"/>
        </div>
      </div>
      <Dialog header="Item Group" :modal="true" :visible.sync="displayBasic"
              :closable=false :style="{width: '50vw'}" :contentStyle="{'overflow': 'visible'}">
        <div class="p-fluid p-formgrid p-grid ">
          <!--          <div class="p-field p-col-12 p-md-4"></div>-->
          <div class="p-field p-col-12 p-md-4">
            <label for="name" style="font-size:12px">Name<span style="color:red">*</span></label>
            <InputText ref="name" v-model.trim="name" id="name"/>
          </div>
          <div class="p-field p-col-12 p-md-4">
            <!-- <div class="p-field p-col-12 p-md-4"> -->
              <label for="property" style="font-size:12px">Property</label>
              <Checkbox v-model="property" :binary="true" id="property"/>
             
            <!-- </div> -->
          </div>
          <!-- <div class="p-field p-col-12 p-md-4">
         
          </div> -->
          <div class="p-field p-col-12 p-md-3 p-mt-5" v-if="property">
            <InputText ref="name" v-model="propertyName" id="name"/>
          </div>
          <div class="p-field p-col-12 p-md-1 p-mt-5" v-if="property">
            <Button class="p-button-raised p-button-rounded" label="Add"
                    @click.prevent="addItemProperty"/>
          </div>
          <div class="p-field p-col-12 p-md-4" v-if="property">
            <MultiSelect v-model="itemPropertyList" :options="propertyLists" optionLabel="propertyName"
                         :filter="true"
                         placeholder="Select Variant"
                         display="chip"/>
          </div>
          <!--          <div class="p-field p-col-12 p-md-4" v-if="property"></div>-->
          <div class="p-field p-col-12 p-md-12" v-if="property">
            <DataTable
              :value="itemPropertyList"
              :paginator="true"
              :rows="4"
              class="p-datatable-responsive p-datatable-gridlines"
              data-key="id"
            >
              <Column header="Property Name" field="propertyName"/>
              <Column field="propertyTypeName" header="Entry Type">
                <template #body="slotProps">
                  <RadioButton inputId="city1" name="UserDefine" value="UserDefine"
                               v-model="slotProps.data[slotProps.column.field]"/>
                  <label for="city1">UserDefine</label>
                  <RadioButton inputId="city2" name="Default" value="Default"
                               v-model="slotProps.data[slotProps.column.field]"/>
                  <label for="city2">Default</label>

                </template>
              </Column>
              <Column header="Details">
                <template #body="sl">
                  <Button class="p-button-secondary" v-if="sl.data['propertyTypeName'] !== 'UserDefine'" label="Details"
                          @click.prevent="openDetailsDialog(sl.data.childIItemMasterPropertyList)"/>
                </template>
              </Column>
              <Column>
                <template #body="sl">
                  <Button class="p-button-danger p-button-text" label="Remove"
                          @click.prevent="removeItemProperty(sl.index)"/>
                </template>
              </Column>
            </DataTable>
          </div>
        </div>
        <template #footer>
          <!-- <div class="p-fluid p-formgrid p-grid">
            <div class="p-field p-col-12 p-md-8"> -->
              <Button class="p-button-raised" :label="editing?'Update':'Add'"
                      @click.prevent="addItemGroup"/>
              <Button class="p-button-raised p-button-info" v-if="!editing" label="Add & New"
                      @click.prevent="saveAndNewItemGroup"/>
              <Button class="p-button-raised p-button-danger" label="Cancel" @click.prevent="cancel"/>
            <!-- </div>
          </div> -->
        </template>
      </Dialog>
      <Dialog header="Detail Setup" :visible.sync="detailDialog"
              :style="{width: '50vw'}" :modal="true" :closable=false :contentStyle="{'overflow': 'auto'}">
        <div class="p-fluid p-formgrid p-grid">
          <div class="p-field p-col-4">
            <label> Parent Property</label>
            <InputText v-model="parentName"/>
          </div>
          <div class="p-field p-col-1">
            <Button class="p-button-raised p-mt-5" label="Add" @click.prevent="addChildItemProperty"/>
          </div>

          <DataTable
            :value="childIItemMasterPropertyList"
            :paginator="true"
            :rows="4"
            class="p-datatable-gridlines">
            <Column header="Property Name" field="propertyName">
            </Column>
            <Column>
              <template #body="sl">
                <Button class=" p-button-text p-button-danger" label="Remove"
                        @click.prevent="removeParentProperty(sl.index)"/>
              </template>
            </Column>
          </DataTable>

        </div>
        <template #footer>
          <Button class="p-button-raised p-button-rounded" label="Save" @click.prevent="saveChildItemProperty"/>
          <Button class="p-button-raised p-button-danger" label="Back"
                  @click.prevent="cancelPropertyDialog"/>
        </template>
      </Dialog>
    </form>
  </div>
</template>
<script>
import Dialog from 'primevue/dialog'
import Button from 'primevue/button'
import InputText from 'primevue/inputtext'
import Checkbox from 'primevue/checkbox'
import MultiSelect from 'primevue/multiselect'
import DataTable from 'primevue/datatable'
import Column from 'primevue/column'
import RadioButton from 'primevue/radiobutton'

export default {
  name: 'itemgroup',
  data() {
    return {
      name: '',
      displayBasic: false,
      dialogShow: false,
      editing: false,
      id: null,
      loading: false,
      property: false,
      childIItemMasterPropertyList: [],
      parentName: '',
      propertyName: '',
      itemPropertyList: [],
      detailDialog: false
    }
  },
  computed: {
    propertyLists() {
      return this.$store.state.itemgroup.itemPropertyLists
    }
  },
  mounted() {
    this.propertyList()
  },
  methods: {
    async addItemGroup() {
      let response = ''
      if (this.name === '') {
        this.$toast.add({severity: 'error', summary: '', detail: 'Item Group name cannot be empty!', life: 10000})
        return
      }
      let itemGroup = {
        name: this.name,
        id: this.id,
        groupItemPropertyDTOList: this.itemPropertyList
      }
      if (!this.editing) {
        this.loading = !this.loading
        response = await this.$store.dispatch('createItemGroup', itemGroup)
        this.$emit('set_data', response.data.data)
        this.loading = false
      } else {
        this.loading = !this.loading
        response = await this.$store.dispatch('updateItemGroup', itemGroup)
        this.loading = false
      }
      this.responseValue(response)
      this.closeBasic()
    },
    async saveAndNewItemGroup() {
      let response = ''
      if (this.name === '') {
        this.$toast.add({severity: 'error', summary: '', detail: 'Item group name cannot be empty!', life: 10000})
        return
      }
      let itemGroup = {
        name: this.name,
        id: this.id
      }
      this.loading = !this.loading
      response = await this.$store.dispatch('createItemGroup', itemGroup)
      this.$emit('set_data', response.data.data)
      this.loading = false
      this.responseValue(response)
    },
    cancel() {
      this.name = ''
      this.property = false
      this.propertyName = ''
      this.itemPropertyList = []
      this.childIItemMasterPropertyList = []
      this.editing = false
      this.closeBasic()
    },
    responseValue(response) {
      if (response.data.status === 'ERROR') {
        this.$toast.add({severity: 'error', summary: '', detail: response.data.message, life: 10000})
        return
      } else {
        this.$toast.add({severity: 'success', summary: '', detail: response.data.message, life: 10000})
        this.resetResponse()
        return
      }
    },
    async propertyList() {
      await this.$store.dispatch('loadItemPropertyList')
    },
    editItemGroup(data) {
      this.editing = true
      this.name = data.name
      this.id = data.id
      this.openBasic()
    },
    openBasic() {
      this.displayBasic = true
    },
    closeBasic() {
      this.displayBasic = false
    },
    resetResponse() {
      this.editing = false
      this.name = ''
      this.property = false
      this.propertyName = ''
      this.itemPropertyList = []
    },
    deleteMessage(value) {
      this.$toast.add({severity: value.messageType, summary: '', detail: value.message, life: 10000})
    },
    addItemProperty() {
      let itemProperty = {
        propertyName: this.propertyName,
        propertyTypeName: 'UserDefine',
        childIItemMasterPropertyList: []
      }
      this.itemPropertyList.push(itemProperty)
      this.propertyName = ''
      this.childIItemMasterPropertyList = []
    },
    removeItemProperty(index) {
      this.itemPropertyList.splice(index, 1)
    },
    addChildItemProperty() {
      let childProperty = {
        parentName: this.parentName
      }
      this.childIItemMasterPropertyList.push(childProperty)
      this.parentName = ''
    },
    removeParentProperty(index) {
      this.childIItemMasterPropertyList.splice(index, 1)
    },
    saveChildItemProperty() {
      this.detailDialog = false
    },
    openDetailsDialog(data) {
      this.childIItemMasterPropertyList = data
      this.detailDialog = true
    },
    cancelPropertyDialog() {
      this.detailDialog = false
    }
  },
  components: {
    Dialog,
    Button,
    InputText,
    Checkbox,
    MultiSelect,
    DataTable,
    Column,
    RadioButton
  }
}
</script>
<style scoped src="@../../../static/css/dialogEntry.css">
</style>



// WEBPACK FOOTER //
// itemGroupDialog.vue?3d058430